/* FiND commerce helpers — unpublished audit theme only. */
(function () {
  'use strict';

  var DUTY_WEIGHT_BY_COUNT = { 5: 2000, 10: 4000, 15: 6000 };
  var dutyAddInFlight = false;
  var cartEnhanceScheduled = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function ensureDienstfinderAlias() {
    var canonical = document.getElementById('find-unit-finder');
    if (!canonical || document.getElementById('dienstfinder')) return;

    var alias = document.createElement('span');
    alias.id = 'dienstfinder';
    alias.setAttribute('aria-hidden', 'true');
    alias.style.position = 'absolute';
    alias.style.width = '1px';
    alias.style.height = '1px';
    alias.style.pointerEvents = 'none';
    canonical.parentNode.insertBefore(alias, canonical);

    if (window.location.hash === '#dienstfinder') {
      window.requestAnimationFrame(function () {
        canonical.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  function injectCommerceStyles() {
    if (document.getElementById('find-commerce-styles')) return;

    var style = document.createElement('style');
    style.id = 'find-commerce-styles';
    style.textContent = [
      '.find-duty-add-status{margin:12px 0 0;min-height:20px;color:rgba(255,255,255,.62);font-size:12px;font-weight:700;line-height:1.45}',
      '.find-duty-add-status.is-success{color:#7ee2a3}',
      '.find-duty-add-status.is-error{color:#ff8b91}',
      '.find-cart-duty-quantity[data-find-duty-cart-enhanced]{display:inline-grid;grid-template-columns:40px 48px 40px;align-items:center;min-height:44px;border:1px solid rgb(var(--color-foreground-rgb)/.18);border-radius:999px;overflow:hidden;color:var(--color-foreground)}',
      '.find-cart-duty-quantity[data-find-duty-cart-enhanced] button{width:40px;height:44px;padding:0;border:0;background:transparent;color:inherit;cursor:pointer;font-size:18px;line-height:1}',
      '.find-cart-duty-quantity[data-find-duty-cart-enhanced] input{width:48px;height:44px;padding:0;border:0;outline:0;background:transparent;color:inherit;text-align:center;font:inherit;font-weight:700;appearance:textfield;-moz-appearance:textfield}',
      '.find-cart-duty-quantity[data-find-duty-cart-enhanced] input::-webkit-inner-spin-button,.find-cart-duty-quantity[data-find-duty-cart-enhanced] input::-webkit-outer-spin-button{appearance:none;-webkit-appearance:none;margin:0}',
      '.find-cart-duty-quantity[data-find-duty-cart-enhanced] button:focus-visible,.find-cart-duty-quantity[data-find-duty-cart-enhanced] input:focus-visible{outline:2px solid currentColor;outline-offset:-3px}',
      '.find-cart-duty-quantity[data-find-duty-cart-enhanced].is-updating{opacity:.55;pointer-events:none}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function normalizeDutyConfigEvent(event) {
    var detail = event && event.detail;
    if (!detail) return;

    var selected = Array.isArray(detail.flavors) ? detail.flavors.length : Number(detail.selected || 0);
    var required = Number(detail.requiredFlavors || detail.required || 0);

    detail.selected = selected;
    detail.required = required;
    detail.complete = required > 0 && selected === required;
  }

  document.addEventListener('find:duty-config-updated', normalizeDutyConfigEvent, true);

  function getDutyRoot() {
    return document.querySelector('[data-duty-variant-cta]');
  }

  function getSelectedDutyButton(root) {
    return root ? root.querySelector('[data-duty-variant-button].is-selected') : null;
  }

  function getDutyQuantity(root) {
    var input = root && root.querySelector('[data-duty-quantity-input]');
    var value = input ? parseInt(input.value, 10) : 1;
    return !isNaN(value) && value > 0 ? value : 1;
  }

  function getDutyFlavorSelections(root) {
    if (!root) return [];
    return Array.prototype.slice
      .call(root.querySelectorAll('input[data-duty-hydroload-choice]:checked'))
      .sort(function (a, b) {
        return (parseInt(a.dataset.dutySlot, 10) || 0) - (parseInt(b.dataset.dutySlot, 10) || 0);
      })
      .map(function (input) { return input.value; });
  }

  function getDutyState(root) {
    var selected = getSelectedDutyButton(root);
    if (!selected) return null;

    var dutyCount = parseInt(selected.dataset.dutyCount, 10) || 5;
    var quantity = getDutyQuantity(root);
    var flavorsPerSet = parseInt(selected.dataset.flavorCount, 10) || Math.max(1, dutyCount / 5);
    var flavors = getDutyFlavorSelections(root);
    var required = flavorsPerSet * quantity;

    return {
      variantId: Number(selected.dataset.variantId),
      dutyCount: dutyCount,
      quantity: quantity,
      flavorsPerSet: flavorsPerSet,
      flavors: flavors,
      required: required,
      complete: flavors.length === required,
      available: selected.dataset.variantAvailable !== 'false'
    };
  }

  function buildDutyCartItems(state) {
    var groups = new Map();

    for (var index = 0; index < state.quantity; index += 1) {
      var setFlavors = state.flavors.slice(index * state.flavorsPerSet, (index + 1) * state.flavorsPerSet);
      var propertyValue = setFlavors.join(', ');
      var current = groups.get(propertyValue);

      if (current) {
        current.quantity += 1;
      } else {
        groups.set(propertyValue, {
          id: state.variantId,
          quantity: 1,
          properties: { 'Geschmäcker': propertyValue }
        });
      }
    }

    return Array.from(groups.values());
  }

  function shippingRateForDutySelection(state) {
    var unitWeight = DUTY_WEIGHT_BY_COUNT[state.dutyCount] || 0;
    var grams = unitWeight * state.quantity;
    var cents = 490;

    if (grams >= 9000) cents = 990;
    else if (grams >= 6000) cents = 890;
    else if (grams >= 3000) cents = 790;
    else if (grams > 1000) cents = 690;

    return { grams: grams, cents: cents };
  }

  function formatEuro(cents) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function updateDutyShippingEstimate(root) {
    var state = getDutyState(root);
    var note = root && root.querySelector('.find-duty-variant-cta__shipping-note');
    if (!state || !note) return;

    var rate = shippingRateForDutySelection(state);
    note.textContent = 'Versand für diese Auswahl (DE): voraussichtlich ' + formatEuro(rate.cents) + ' · DHL · Checkout maßgeblich';
  }

  function setDutyStatus(root, message, kind) {
    if (!root) return;
    var purchase = root.querySelector('.find-duty-variant-cta__purchase');
    if (!purchase) return;

    var status = root.querySelector('[data-find-duty-add-status]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'find-duty-add-status';
      status.setAttribute('data-find-duty-add-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      purchase.insertAdjacentElement('afterend', status);
    }

    status.className = 'find-duty-add-status' + (kind ? ' is-' + kind : '');
    status.textContent = message || '';
  }

  function collectCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (element) {
      var id = element.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function dispatchCartUpdate(cart, sections) {
    var drawer = document.querySelector('cart-drawer-component[auto-open]');
    var hadAutoOpen = !!drawer;
    if (drawer) drawer.removeAttribute('auto-open');

    var event = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'find-duty-commerce',
        data: {
          source: 'find-duty-commerce',
          itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 0,
          sections: sections || {}
        }
      }
    });

    document.dispatchEvent(event);

    if (drawer && hadAutoOpen) {
      window.setTimeout(function () { drawer.setAttribute('auto-open', ''); }, 0);
    }
  }

  async function addDutyToCart(root, event) {
    if (dutyAddInFlight) return;

    var state = getDutyState(root);
    var mainButton = root.querySelector('[data-duty-add-button]');
    var stickyButton = document.querySelector('[data-duty-sticky-action]');

    if (!state || !state.available || !state.complete) {
      setDutyStatus(root, 'Bitte wähle zuerst alle benötigten Geschmäcker aus.', 'error');
      return;
    }

    dutyAddInFlight = true;
    if (mainButton) mainButton.disabled = true;
    if (stickyButton) stickyButton.disabled = true;
    setDutyStatus(root, 'Wird zum Warenkorb hinzugefügt …', '');

    try {
      var sectionIds = collectCartSectionIds();
      var payload = { items: buildDutyCartItems(state) };

      if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname;
      }

      var cartAddUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
      var response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      var result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Die Auswahl konnte nicht zum Warenkorb hinzugefügt werden.');
      }

      var cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
      var cart = await cartResponse.json();
      dispatchCartUpdate(cart, result.sections || {});

      setDutyStatus(root, '✓ Zum Warenkorb hinzugefügt', 'success');
      if (mainButton) mainButton.textContent = '✓ Hinzugefügt';
      if (stickyButton) stickyButton.textContent = '✓ Hinzugefügt';

      window.setTimeout(function () {
        if (mainButton) mainButton.textContent = 'In den Warenkorb legen';
        if (stickyButton) stickyButton.textContent = 'In den Warenkorb legen';
        setDutyStatus(root, '', '');
      }, 2600);
    } catch (error) {
      console.error('FiND Duty add-to-cart failed:', error);
      setDutyStatus(root, error && error.message ? error.message : 'Beim Hinzufügen ist ein Fehler aufgetreten.', 'error');
    } finally {
      dutyAddInFlight = false;
      var latestState = getDutyState(root);
      if (mainButton) mainButton.disabled = !(latestState && latestState.available && latestState.complete);
      if (stickyButton) stickyButton.disabled = !(latestState && latestState.available && latestState.complete);
    }

    if (event && typeof event.preventDefault === 'function') event.preventDefault();
  }

  function initDutyCommerce() {
    var root = getDutyRoot();
    if (!root || root.dataset.findDutyCommerceInitialized === 'true') return;
    root.dataset.findDutyCommerceInitialized = 'true';

    var form = root.querySelector('[data-duty-form]');
    var mainButton = root.querySelector('[data-duty-add-button]');
    var stickyButton = document.querySelector('[data-duty-sticky-action]');

    if (mainButton) {
      mainButton.dataset.availableLabel = 'In den Warenkorb legen';
      if (!mainButton.disabled) mainButton.textContent = 'In den Warenkorb legen';
    }

    if (stickyButton) {
      stickyButton.dataset.defaultLabel = 'In den Warenkorb legen';
      if (!stickyButton.disabled && !/Geschm/.test(stickyButton.textContent || '')) {
        stickyButton.textContent = 'In den Warenkorb legen';
      }
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addDutyToCart(root, event);
      }, true);
    }

    updateDutyShippingEstimate(root);
    document.addEventListener('find:duty-config-updated', function (event) {
      if (!root.contains(event.target)) return;
      updateDutyShippingEstimate(root);
    });
  }

  function enhanceDutyCartLine(control) {
    if (!control || control.dataset.findDutyCartEnhanced === 'true') return;
    var row = control.closest('[data-key]');
    var component = control.closest('cart-items-component');
    if (!row || !component || typeof component.updateQuantity !== 'function') return;

    var existingStrong = control.querySelector('strong');
    var quantity = existingStrong ? parseInt(existingStrong.textContent, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    control.dataset.findDutyCartEnhanced = 'true';
    control.setAttribute('aria-label', 'Duty Menge ändern');
    control.innerHTML = '';

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.setAttribute('aria-label', 'Menge verringern');
    minus.textContent = '−';

    var input = document.createElement('input');
    input.type = 'number';
    input.min = '1';
    input.inputMode = 'numeric';
    input.value = String(quantity);
    input.setAttribute('aria-label', 'Menge');

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.setAttribute('aria-label', 'Menge erhöhen');
    plus.textContent = '+';

    control.appendChild(minus);
    control.appendChild(input);
    control.appendChild(plus);

    function lineNumber() {
      var rows = Array.prototype.slice.call(component.querySelectorAll('[ref="cartItemRows[]"]'));
      return rows.indexOf(row) + 1;
    }

    function submitQuantity(next) {
      next = Math.max(1, parseInt(next, 10) || 1);
      var line = lineNumber();
      if (line < 1) return;
      input.value = String(next);
      control.classList.add('is-updating');
      component.updateQuantity({ line: line, quantity: next, action: 'change' });
      window.setTimeout(function () { control.classList.remove('is-updating'); }, 700);
    }

    minus.addEventListener('click', function () { submitQuantity((parseInt(input.value, 10) || 1) - 1); });
    plus.addEventListener('click', function () { submitQuantity((parseInt(input.value, 10) || 1) + 1); });
    input.addEventListener('change', function () { submitQuantity(input.value); });

    var summary = row.querySelector('.find-cart-duty-summary__flavors');
    if (summary) {
      var label = summary.querySelector('span');
      var value = summary.querySelector('strong');
      if (label && value) {
        var flavorCount = value.textContent.split(',').map(function (item) { return item.trim(); }).filter(Boolean).length;
        label.textContent = flavorCount === 1 ? 'Geschmack je Set:' : 'Geschmäcker je Set:';
      }
    }
  }

  function enhanceDutyCart() {
    document.querySelectorAll('.find-cart-duty-quantity').forEach(enhanceDutyCartLine);
  }

  function scheduleDutyCartEnhance() {
    if (cartEnhanceScheduled) return;
    cartEnhanceScheduled = true;
    window.requestAnimationFrame(function () {
      cartEnhanceScheduled = false;
      enhanceDutyCart();
    });
  }

  ready(function () {
    injectCommerceStyles();
    ensureDienstfinderAlias();
    initDutyCommerce();
    enhanceDutyCart();

    document.addEventListener('cart:update', scheduleDutyCartEnhance);
    document.addEventListener('shopify:section:load', function () {
      initDutyCommerce();
      ensureDienstfinderAlias();
      scheduleDutyCartEnhance();
    });

    var observer = new MutationObserver(scheduleDutyCartEnhance);
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  });
})();
